import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  align-items: center;

  .connector {
    height: 2px;
    background-color: #ccc;
    flex: 1;
  }
`;

const Step = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  position: relative;

  ${({ theme, active }) =>
    active && `background-color: ${theme.colors.brandPrimary};`};

  &:first-child .connector {
    display: none;
  }

  &:last-child .connector {
    display: none;
  }
`;

function Steps({ quizCards, currentSection }) {
  return (
    <Container>
      {quizCards.map((step, i) => (
        <>
          <Step active={i === currentSection}>{i + 1}</Step>
          {i !== quizCards.length - 1 && <div className="connector" />}
        </>
      ))}
    </Container>
  );
}

Steps.propTypes = {
  quizCards: PropTypes.arrayOf(PropTypes.shape({})),
  currentSection: PropTypes.number,
};

Steps.defaultProps = {
  quizCards: [],
  currentSection: 1,
};

export default Steps;
